import React, { FC } from 'react'
import { useTheme } from '@shared/lib'
import { Partners, usePartner } from '@shared/lib/partner'

const RedFireIcon: FC<{ color?: string }> = ({ color = '#F95721' }) => {
  const theme = useTheme()
  const { partner } = usePartner()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 14.0002C4 13.412 4.03076 12.9831 4.09406 12.6624C4.31231 11.1196 4.96 9.19441 6.53699 6.46313C6.92776 5.78633 7.91827 5.83311 8.33475 6.49439C8.40211 6.60135 8.46981 6.7063 8.53776 6.8094C9.50269 4.91585 10.6892 3.39871 11.9827 2.2932C12.8853 1.52175 14.1334 2.39067 14.4654 3.53069C14.9449 5.17713 16.0363 6.56137 17.1243 7.94131C18.5651 9.76878 20 11.5887 20 14.0002C20 18.2058 16.9499 21.5308 12.8836 21.9543C12.6371 21.9849 12.3446 21.9999 11.9999 21.9999C7.49993 21.9999 4 18.5053 4 14.0002ZM13.8878 14.1333C14.5024 15.0294 15 15.7551 15 17.0833C15 18.75 13.7899 20 12.0378 20C10.2857 20 9 18.75 9 17.0833C9 14.2823 10.5024 11.7023 12.0378 10C12.5033 12.1144 13.2571 13.2136 13.8878 14.1333Z"
        fill={partner === Partners.CDEK || partner === Partners.GENBANK ? theme.colors.icon.white : color || '#F95721'}
      />
    </svg>
  )
}

export default RedFireIcon
